/*
 * INO Beauty - Sepet tutari esigi gecince ucretsiz hediye (Iconic Bag)
 *
 * Esik tutari ve hediye urunu TEMA DUZENLEYICIDEN yonetilir:
 *   Tema duzenleyici > Sepet cekmecesi (Cart drawer) > "Ucretsiz Hediye"
 * Ayarlar sections/cart-drawer.liquid icinde window.inoFreeGift olarak her
 * sayfaya (sepet sayfasi dahil) basilir; bu dosyada sabit esik/urun yoktur.
 *
 * Urun ara toplami (hediye haric, kupon/kargo haric) esigi gectiginde hediyeyi
 * sepete otomatik ekler, esigin altina dustugunde otomatik cikarir.
 * FoxEcom Sleek temasinin native sepet akisini (cartUpdate pubsub) kullanir.
 *
 * Not: Hediyenin checkout'ta 0 TL olmasi Shopify Admin > Indirimler'deki
 * "iconicbag_gift" otomatik indiriminden gelir. Esik degistiginde oradaki
 * minimum tutar da ayni yapilmalidir.
 */
(function () {
  if (window.__inoFreeGiftInit) return;
  window.__inoFreeGiftInit = true;

  function cfg() { return window.inoFreeGift || null; }
  function threshold() { var c = cfg(); return c ? Number(c.threshold) || 0 : 0; }
  function giftVariantId() { var c = cfg(); return c ? Number(c.variantId) || 0 : 0; }
  function isActive() { var c = cfg(); return !!(c && c.active && threshold() > 0 && giftVariantId() > 0); }

  function isAutoGift(it) {
    return !!(it && it.properties && it.properties._ino_free_gift === 'true');
  }
  function isGiftLine(it) {
    var vid = giftVariantId();
    return isAutoGift(it) || (vid > 0 && it.variant_id === vid);
  }

  function eligibleTotal(cart) {
    return ((cart && cart.items) || []).reduce(function (sum, it) {
      return isGiftLine(it) ? sum : sum + it.original_line_price;
    }, 0);
  }

  function formatMoney(cents) {
    if (window.FoxTheme && FoxTheme.Currency && FoxTheme.settings) {
      return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
    }
    return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + ' TL';
  }
  function formatMoneyShort(cents) {
    return String(formatMoney(cents)).replace(/[.,]00(?=[^0-9]*$)/, '');
  }

  // Sepet basligindaki hediye esik cubugu (snippets/free-gift-goal.liquid).
  // Drawer basligi section render'inda yenilenmedigi icin cart:updated
  // olayiyla guncellenir (free-shipping-goal ile ayni desen). Esik, urun adi ve
  // gorseli window.inoFreeGift'ten senkronlanir (sepet sayfasi dahil).
  if (window.customElements && !customElements.get('free-gift-goal')) {
    customElements.define(
      'free-gift-goal',
      class extends HTMLElement {
        connectedCallback() {
          this.onCartUpdated = this.onCartUpdated || this.handleCartUpdated.bind(this);
          document.addEventListener('cart:updated', this.onCartUpdated);
          this.update(Number(this.dataset.eligibleTotal) || 0);
        }
        disconnectedCallback() {
          document.removeEventListener('cart:updated', this.onCartUpdated);
        }
        handleCartUpdated(event) {
          var cart = event && event.detail && event.detail.cart;
          if (!cart || !cart.items) return;
          this.update(eligibleTotal(cart));
        }
        update(amount) {
          var c = cfg();
          if (c && !isActive()) {
            this.classList.add('hidden');
            return;
          }
          var min = threshold() || Number(this.dataset.minimumAmount) || 0;
          if (min <= 0) return;
          this.classList.toggle('hidden', amount <= 0);
          this.classList.toggle('free-gift-goal--done', amount >= min);
          var bar = this.querySelector('progress-bar');
          if (bar) bar.style.setProperty('--percent', Math.min((amount * 100) / min, 100) + '%');
          if (amount < min) {
            var left = this.querySelector('[data-left-to-spend]');
            if (left) left.innerHTML = formatMoney(min - amount);
          }
          if (c) {
            var th = this.querySelector('[data-threshold-amount]');
            if (th) th.innerHTML = formatMoneyShort(min);
            var title = this.querySelector('.free-gift-goal__preview-title');
            if (title && c.productTitle) title.textContent = c.productTitle;
            var img = this.querySelector('.free-gift-goal__preview-image');
            if (img && c.productImage) {
              img.src = c.productImage;
              if (c.productTitle) img.alt = c.productTitle;
            }
          }
        }
      }
    );
  }

  if (window.Shopify && window.Shopify.designMode) return;

  function whenReady(cb) {
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.routes && FoxTheme.utils) return cb();
    var tries = 0;
    var timer = setInterval(function () {
      if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.routes && FoxTheme.utils) {
        clearInterval(timer);
        cb();
      } else if (++tries > 100) {
        clearInterval(timer);
      }
    }, 150);
  }

  whenReady(function () {
    var working = false;

    function fetchCfg(type) {
      try { return FoxTheme.utils.fetchConfig(type || 'json'); }
      catch (e) {
        return { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      }
    }

    function rootUrl() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    function bundledSections() {
      var sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
      );
      return sections;
    }

    function getCart() {
      return fetch(FoxTheme.routes.cart_url, { headers: { Accept: 'application/json' } }).then(function (r) {
        return r.json();
      });
    }

    // Sepeti yeniden cek, render edilmis section'lari ekle ve temanin
    // cartUpdate olayini yayinla -> drawer + header sayaci native guncellenir.
    function broadcast(operationResponse) {
      return getCart().then(function (cart) {
        if (operationResponse && operationResponse.sections) cart.sections = operationResponse.sections;
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'ino-free-gift', cart: cart });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
        return cart;
      });
    }

    function addGift() {
      var body = JSON.stringify({
        items: [{ id: giftVariantId(), quantity: 1, properties: { _ino_free_gift: 'true' } }],
        sections: bundledSections(),
        sections_url: window.location.pathname
      });
      return fetch(FoxTheme.routes.cart_add_url, Object.assign({}, fetchCfg('json'), { body: body }))
        .then(function (r) { return r.json(); })
        .then(broadcast);
    }

    // Satir anahtari (key) -> yeni adet. Birden fazla hediye satirini tek
    // istekte duzeltir (urun degistiginde eski hediye satiri da kalkar).
    function updateLines(updates) {
      var body = JSON.stringify({
        updates: updates,
        sections: bundledSections(),
        sections_url: window.location.pathname
      });
      return fetch(rootUrl() + 'cart/update.js', Object.assign({}, fetchCfg('json'), { body: body }))
        .then(function (r) { return r.json(); })
        .then(broadcast);
    }

    function reconcile(knownCart) {
      if (working) return Promise.resolve();
      if (!cfg()) return Promise.resolve();
      var source = knownCart && knownCart.items ? Promise.resolve(knownCart) : getCart();
      return source.then(function (cart) {
        var items = (cart && cart.items) || [];
        var vid = giftVariantId();
        var giftLines = items.filter(isGiftLine);
        var hasOtherItems = items.some(function (it) { return !isGiftLine(it); });
        var qualifies = isActive() && hasOtherItems && eligibleTotal(cart) >= threshold();

        var updates = {};
        var changed = false;
        var keep = null;
        giftLines.forEach(function (line) {
          if (qualifies && !keep && line.variant_id === vid) {
            keep = line;
            if (line.quantity !== 1) { updates[line.key] = 1; changed = true; }
          } else {
            updates[line.key] = 0;
            changed = true;
          }
        });
        var needAdd = qualifies && !keep;
        if (!changed && !needAdd) return;

        working = true;
        var step = changed ? updateLines(updates) : Promise.resolve();
        return step
          .then(function () { if (needAdd) return addGift(); })
          .finally(function () { working = false; });
      }).catch(function () { working = false; });
    }

    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (working) return;
      if (event && event.source === 'ino-free-gift') return;
      reconcile(event && event.cart && event.cart.items ? event.cart : null);
    });

    document.addEventListener('cart:refresh', function () {
      if (working) return;
      setTimeout(function () { reconcile(); }, 700);
    });

    window.addEventListener('pageshow', function () { reconcile(); });

    // "Hemen Satin Al" (dynamic checkout) sepeti atlayip dogrudan checkout'a
    // gidiyor. Yakalayip once urunu sepete ekliyoruz; reconcile hediyeyi ekler;
    // ardindan checkout'a yonlendiriyoruz. Boylece hizli satin alma yolunda da
    // esik ustu hediye uygulanir.
    function buyNowThenCheckout(form, btn) {
      var fd;
      try { fd = new FormData(form); } catch (e) { window.location.href = '/cart'; return; }
      if (btn) { btn.setAttribute('aria-busy', 'true'); btn.style.pointerEvents = 'none'; btn.style.opacity = '0.7'; }
      fetch(FoxTheme.routes.cart_add_url, { method: 'POST', headers: { Accept: 'application/javascript' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status && res.status !== 200) throw new Error('add-failed');
          return reconcile();
        })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { window.location.href = '/cart'; });
    }

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest('.shopify-payment-button__button--unbranded');
      if (!btn) return;
      var form = btn.closest('form[action*="/cart"]') || btn.closest('form');
      if (!form) return;
      var idEl = form.querySelector('[name="id"]');
      if (!idEl || !idEl.value || idEl.disabled) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      buyNowThenCheckout(form, btn);
    }, true);

    reconcile();
  });
})();
